/**
 * Overall Includes Filter - for the entire PC profile, is good at limiting include options for 
 * certian options that have been selected in the parent part creator profile, 
 * for example SCEs need to show the SC150 include when the OP Short code is 5, but SC300 include for all other OP values
 * @param {any} s - the current state
 * @param {any} d - the parent part creator profile
 * 
 * There is no input for this, it is driven by the name of the PC profile
 * 
 */
export function includesFilter(s, d) {
    let rtn = [];

    // If we are 
    if (d.name == "SCE Copy" || d.name == "SCD Copy") {
        let _c1 = {}; getOptionValueWithSC(d.id, s, "OP", (g, o) => { _c1 = o; });
        if (_c1?.name == '5') rtn = d.includes.filter(i =>
            i.name == "USB Cable" || i.name == "Channel Setup - SC150s");
        else rtn = d.includes.filter(i =>
            i.name == "USB Cable" || i.name == "Channel Setup - SC300s");
    } else {
        rtn = d.includes;
    }

    return rtn;
}

/**
 * This filter allows the filtering of options in the include, based on selections from the parent
 * For example in SCEs a subsed of preliminary choices are provided before a user can build a SC with an SCE
 * (I.E. SCC-PREWIRE, SCC-NONE etc...) 
 * This option can also be used to force selections deeper in the included PC profile. to do this create a
 * new group on the child PC profile, this new group will be hidden when that product is build by itself, but activated 
 * by this code when used as an include. By assigning two options to that group you can force the selection of one of them
 * by filtering out the other as seen below. *** When doing this, be sure the assign all of the block options two both of 
 * the groups, otherwise you will find a situation where one of these options is automaticaly picked when the product is 
 * built by itself.
 * 
 * The input for this is the black box at the bottom of each include configuration.
 * 
 * @param {any} dat - the selected part creator
 * @param {any} val - the text of the part number
 * @param {any} self - reference to the react component
 */
export function includeFilter(def, newdata, parent, self) {

    // This filter used to allow for the selection of SCC-PREWIRE as a preliminary option to choosing
    // a Signal Conditioner(s), the SCC-PREWIRE option went away, which could have lead to the removal of the 
    // filter, however there was another requirement that only 4-20 options should be allowed with SCEs which made it so 
    // that the filter below auto-selects 1 hidden option that is hardwired to the 4-20 option
    if (def == "SCE_SC3_Filter") {
        newdata.forEach(d => {
            // Look for the group we will filter (The Channel)
            let mc = d.configgroup.filter(f => f.shortcode == "SCE")[0];
            if (mc) {
                // Look for the value we will filter on (The input Signal)
                self.getOptionValueWithSC(parent, self.state, "OP", (grp, opt) => {
                    // Apply the filter
                    if (opt.name == '1' || opt.name == '2') {
                        // filter to options whos names start with 1 (Single Channel)
                        mc.configs = mc.configs.filter(d => d.name.startsWith('1'));

                        // Even though option 3 is inactive, this blocks it as well, 
                        //all SCC - PREWIRE and SCC - NONE have also been eliminated
                        // || d.name.startsWith('3'));// || d.name.startsWith('S'));
                    } else {
                        // filter to options whos names start with 2 (Dual Channel)
                        mc.configs = mc.configs.filter(d => d.name.startsWith('2'));

                        //all SCC - PREWIRE and SCC - NONE have been eliminated
                        // || d.name.startsWith('S'));
                    }
                    let xyz = 0;
                });
            }
        });
    }

    if (def == "PXD_DD_Filter") {
        newdata.forEach(d => {
            // Look for the group we will filter (The Channel)
            let mc = d.configgroup.filter(f => f.shortcode == "SCE")[0];
            if (mc) {
                // Look for the value we will filter on (The input Signal)
                self.getOptionValueWithSC(parent, self.state, "OP", (grp, opt) => {
                    // Apply the filter
                    if (opt.name == '1' || opt.name == '2') {
                        // filter to options whos names start with 1 (Single Channel)
                        mc.configs = mc.configs.filter(d => d.name.startsWith('1'));

                        // Even though option 3 is inactive, this blocks it as well, 
                        //all SCC - PREWIRE and SCC - NONE have also been eliminated
                        // || d.name.startsWith('3'));// || d.name.startsWith('S'));
                    } else {
                        // filter to options whos names start with 2 (Dual Channel)
                        mc.configs = mc.configs.filter(d => d.name.startsWith('2'));

                        //all SCC - PREWIRE and SCC - NONE have been eliminated
                        // || d.name.startsWith('S'));
                    }
                    let xyz = 0;
                });
            }
        });
    }
}

/**
 * The Ouput Frequency Filtre for SC3s
 * @param {any} def - The definition 'name' of the filter
 * @param {any} pc - the part creator id
 * @param {any} state - the state collection
 * @param {any} group - The group being hit by the current iteration
 * @param {any} option - the option of the current iteration
 * @param {any} self - reference to the react component
 */
export function internalFilter(def, pc, state, group, option, self) {
    if (def == "SC3_FSR_FILTER") {
        // if the code of what changed is output unit OU1 or OU2
        if (group.shortcode == "OU1" || group.shortcode == "OU2") // ouput unit 1
        {
            // define the code of the group to collect data from
            let fsf = "FS1"
            let ouf = "OU1"

            // different groups for the second channel
            if (group.shortcode.endsWith('2'))
            {
                fsf = "FS2"
                ouf = "OU2"
            }

            // collect the following groups
            // IU- input unit, IS-input source, FS1-full scale, OU1- output unit
            let g_iu = {}; let _iu = {}; self.getOptionValueWithSC(pc, state, "IU", (g, o) => { _iu = o; g_iu = g; });
            let g_is = {}; let _is = {}; self.getOptionValueWithSC(pc, state, "IS", (g, o) => { _is = o; g_is = g; });
            let g_fs1 = {}; let _fs1 = {}; self.getOptionValueWithSC(pc, state, fsf, (g, o) => { _fs1 = o; g_fs1 = g; });
            let g_ou1 = {}; let _ou1 = {}; self.getOptionValueWithSC(pc, state, ouf, (g, o) => { _ou1 = o; g_ou1 = g; });

            // get the numeric value of input source and divide by 1000
            let ist = parseFloat(_is.grouptitle ? _is.grouptitle : '10000') / 1000;

            // for each full scale range option of the current channel
            g_fs1.configs.forEach(c => {
                let ifs = 1000;

                // if the input unit and output unit match
                if (
                    (_iu.name == 'G' && _ou1.name == 'G') ||
                    (_iu.name == 'I' && _ou1.name == 'I') ||
                    (_iu.name == 'D' && _ou1.name == 'D')) {

                    // get the numeric value of the full scale range option
                    ifs = parseFloat(c.grouptitle ? c.grouptitle.replaceAll('0-', '') : '1000');

                    // If the 'input source' * the 'full scale range' is greater than 10 block it
                    if (ifs * ist > 10) {
                        c.openclose = -100;
                    } else {
                        //c.openclose = 0;
                    }
                }
            });
            //}
        }
    }
}

/**
 * 
 * @param {any} s - The state variable.
 * @param {any} sc - The shortcode of the group to retrieve the value from.
 * @param {any} cb - The callback method to send the group and value to.
 */
function getOptionValueWithSC(pc, s, sc, cb) {
    let group = {};
    let option = {};

    s.data.forEach(d => {
        if (d.id == pc) {
            let _g = d.configgroup.find(f => f.shortcode == sc);
            group = _g || { name: '', type: '1' };
        }
    });

    let _o = getConfigList(s, pc).find(f => f.id == s.selections[pc + '_' + group.id]);
    option = _o || { name: '', grouptitle: '', ord: 0 };

    if (group.type == '3' || group.type == '4') {
        option = { name: s.selections[pc + '_' + group.id], grouptitle: s.selections[pc + '_' + group.id], ord: 0 };
    }

    cb(group, option);
}

function getConfigList(s, pc) {
    return getConfigListD(s.data, pc)
}

function getConfigListD(data, pc) {
    let cl = data.find(d => (d.id == pc))
    if (cl) return cl.configlist;

    // Check the main implementation in fetchData
    // this line will return this.configlist, which may prevent this
    // from being the master version of this function.
    else return null;
}